import React from 'react'
import {
  Typography,
  Container,
  createStyles,
  withStyles,
} from '@material-ui/core'

import { flexBreakpoint } from '../../../Home/Features/styles'

const styles = (theme) => {
  return createStyles({
    section: {
      padding: '3.1875rem 0 4.0625rem',
      backgroundColor: theme.palette.primary.main,
    },
    title: {
      marginBottom: '3.6875rem',
    },
    list: {
      paddingLeft: 0,
      [theme.breakpoints.up(flexBreakpoint)]: {
        display: 'flex',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
      },
    },
  })
}

const Features = ({ classes, title, children }) => {
  return (
    <section className={classes.section}>
      <Container>
        <Typography variant="h2" className={classes.title} align="center">
          {title}
        </Typography>
        <ul className={classes.list}>{children}</ul>
      </Container>
    </section>
  )
}

export default withStyles(styles)(Features)
